module.exports = __webpack_public_path__ + "img/uhive_popup_logo.fcd8c450.svg";